import { FC, ReactNode } from 'react'

import styled from 'styled-components'

import LinkIcon from 'src/Assets/Svg/campaignDetails/Link.svg?react'
import { secondaryButtonStyles } from 'src/Components/Buttons/PrimaryButton'
import { variables } from 'src/Styled/variables'

export interface LinkButtonProps {
  href: string
  children: ReactNode
  icon?: ReactNode
  className?: string
}

const StyledLink = styled.a<{ $loading?: boolean }>`
  display: inline-flex;
  height: 32px;
  padding: 0 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  box-sizing: border-box;
  text-decoration: none;
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;

  ${secondaryButtonStyles}

  svg {
    flex-shrink: 0;
  }

  &:hover {
    color: ${({ theme }) => theme.color.darkGrey};
  }
`

export const LinkButton: FC<LinkButtonProps> = ({
  href,
  children,
  icon = <LinkIcon width={16} height={16} />,
  className,
}) => (
  <StyledLink
    href={href}
    target='_blank'
    rel='noreferrer'
    className={className}
  >
    {icon}
    <span>{children}</span>
  </StyledLink>
)
